import styles from './FJFilterAndSearch.module.less';
import FJConstant from '../../../../constants/FJConstant.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJSearchContainer from '../../../../common/components/FJSearch/FJSearchContainer.jsx';
import { useRef } from 'react';
import FJHorizontalScroller from '../../../../common/components/FJScroller/FJHorizontalScroller.jsx';

const filterList = [
    { value: FJConstant.ALL, text: 'all' },
    { value: FJConstant.IMAGE_TO_IMAGE, text: 'image-to-image' },
    { value: FJConstant.TEXT_TO_IMAGE, text: 'text-to-image' },
    { value: FJConstant.PHOTO_EDITOR, text: 'photo-editor' },
];
const FJFilterAndSearch = props => {
    const { filterType, searchText, onFilterTypeChange, onSubmit, onValueChange } = props;

    const searchRef = useRef(null);
    const _scrollerRef = useRef(null);
    const _containerRef = useRef(null);

    const _onFilterTypeChange = (e, value) => {
        onFilterTypeChange(value);

        // 将点击的元素在滚动条中居中
        const clickedElement = e.currentTarget;
        const containerElement = _containerRef.current;

        if (clickedElement && _scrollerRef.current && containerElement) {
            const elementLeft = clickedElement.offsetLeft;
            const elementWidth = clickedElement.offsetWidth;
            const containerWidth = containerElement.offsetWidth;

            // 计算居中位置: 元素左边距 - (容器宽度的一半 - 元素宽度的一半)
            const scrollPosition = elementLeft - containerWidth / 2 + elementWidth / 2;

            _scrollerRef.current.scrollToLeft(scrollPosition, 'smooth');
        }
    };

    return (
        <div className={styles.box}>
            <div className={styles.left} ref={_containerRef}>
                <FJHorizontalScroller className={styles.scroller_box} ref={_scrollerRef}>
                    <div className={styles.filter_box}>
                        {filterList.map((item, index) => (
                            <div
                                className={classNames(styles.item, filterType === item.value ? styles.active : '')}
                                key={index}
                                onClick={e => {
                                    _onFilterTypeChange(e, item.value);
                                }}
                            >
                                {FJLocalStore._(item.text)}
                            </div>
                        ))}
                    </div>
                </FJHorizontalScroller>
            </div>

            <div className={styles.search_box}>
                <FJSearchContainer
                    ref={searchRef}
                    theme='theme-mini'
                    isElement={false}
                    style={{ height: 42, border: 'none' }}
                    className={styles.search}
                    onChange={onValueChange}
                    search={onSubmit}
                    placeHolder={FJLocalStore._('search-for-images')}
                />
            </div>
        </div>
    );
};

FJFilterAndSearch.propTypes = {
    filterType: PropTypes.string.isRequired,
    searchText: PropTypes.string.isRequired,
    onFilterTypeChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default FJFilterAndSearch;
